import { render, staticRenderFns } from "./WaterSources.vue?vue&type=template&id=5fd03e6e"
import script from "./WaterSources.vue?vue&type=script&lang=js"
export * from "./WaterSources.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports